var React = require('react');

function IcNavSchedule (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16 2h-1V0h-2v2H5V0H3v2H2C.9 2 0 2.9 0 4v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 16H2V8h14v10zM2 6h14V4H2v2z","fill":"currentColor"}));
}

IcNavSchedule.defaultProps = {"fill":"none","viewBox":"0 0 18 20"};

module.exports = IcNavSchedule;

IcNavSchedule.default = IcNavSchedule;
